import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import closeIcon from "../assets/icons/close-outline.svg";
// import '../assets/css/modal.css';
const ConfirmDeleteModal = ({
  isOpenDelete,
  setIsOpenDelete,
  hideModal,
  title,
}) => {
  function confirmDelete() {
    setIsOpenDelete(false);
  }
  return (
    <Modal show={isOpenDelete} onHide={hideModal} className="modal-up">
      <ModalHeader>
        {" "}
        <h4 className="text-center"> Informations </h4>
        {/* <button
          className="btn btn-link float-right"
          onClick={() => setIsOpenDelete(false)}
        >
          <img src={closeIcon} alt="close icon" />{" "}
        </button> */}
      </ModalHeader>
      <ModalBody>
        {/* <button
          className="btn btn-link float-right"
          onClick={() => setIsOpenDelete(false)}
        >
          <img src={closeIcon} alt="close icon" />{" "}
        </button> */}
        <h5 className="text-center"> {title} </h5>
        <div className="row pt-20">
          <div className="col">
            <button
              className="btn-danger-al float-right"
              onClick={confirmDelete}
            >
              OK
            </button>
          </div>
          {/* <div className="col">
            <button
              className="btn-secondary-al "
              onClick={() => {
                setIsOpenDelete(false);
              }}
            >
              Non
            </button>
          </div> */}
        </div>
      </ModalBody>
    </Modal>
  );
};
export default ConfirmDeleteModal;
